import Api from './Api'
import ApiAuth from './ApiAuth'

export const Account = {
    login(context, data) {
        data.grant_type = 'password';
        data.client_id = `${process.env.VUE_APP_CLIENT_ID}`;
        data.client_secret = `${process.env.VUE_APP_CLIENT_SECRET}`;
        return new Promise((resolve, reject) => {
            Api().post('/login', data).then(response => {
                localStorage.setItem('user-token', response.data.access_token);
                localStorage.setItem('refresh-token', response.data.refresh_token);
                resolve(response.data);
                window.location.href = '/dashboard';
            }).catch((error) => {
                localStorage.removeItem('user-token');
                localStorage.removeItem('refresh-token');
                reject(error.response);
            });
        });
    },
    logout(context, data) {
        return new Promise((resolve, reject) => {
            console.log('test');
            localStorage.removeItem('user-token');
            localStorage.removeItem('refresh-token');
            window.location.href = '/login';
        });
    },
    create(context, data) {
        return new Promise((resolve, reject) => {
            Api().post('/account', data).then(response => {
                context.commit('setCreatedUser', response.data);
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    activate(context, data) {
        return new Promise((resolve, reject) => {
            Api().put('/activate', data).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    forgotPassword(context, data) {
        return new Promise((resolve, reject) => {
            Api().post('/forgotten_password', data).then(response => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    changePassword(context, data) {
        return new Promise((resolve, reject) => {
            Api().post('/change_password', data).then(response => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    accountMe(context) {
        return new Promise((resolve, reject) => {
            ApiAuth().get('/account/me').then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    checkOut(context, data) {
        return new Promise((resolve, reject) => {
            Api().post(`/check_out/${data.id}`, data.data).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    extend(context) {
        return new Promise((resolve, reject) => {
            ApiAuth().post('/extend').then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    upgrade(context, planId) {
        return new Promise((resolve, reject) => {
            ApiAuth().post('/upgrade', {plan_id: planId}).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error.response);
            });
        })
    }

}
